import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPuzzle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconPuzzle"><Path d="M9.5 4V3.5C9.5 2.11929 10.6193 1 12 1C13.3807 1 14.5 2.11929 14.5 3.5V4H20.25C20.6642 4 21 4.33579 21 4.75V9C21 9.27614 20.7761 9.5 20.5 9.5C19.1193 9.5 18 10.6193 18 12C18 13.3807 19.1193 14.5 20.5 14.5C20.7761 14.5 21 14.7239 21 15V19.25C21 19.6642 20.6642 20 20.25 20H3.75C3.33579 20 3 19.6642 3 19.25V4.75C3 4.33579 3.33579 4 3.75 4H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPuzzle;
